module.exports = __webpack_public_path__ + "static/media/cover_template2.003d8e6a.jpg";